import { useEffect, useState } from 'react';

import { viewportSizes } from '@/utils/mediaQueries';

export const breakpoints = ['mobile', 'tabletPortrait', 'tabletLandscape', 'laptop', 'desktop', 'unknown'] as const;

export type Breakpoint = (typeof breakpoints)[number];

const getCurrentViewport = (viewportWidth: number): Breakpoint => {
  const breakpoints: { size: number; name: Breakpoint }[] = [
    { size: viewportSizes.TABLET_PORTRAIT, name: 'mobile' },
    { size: viewportSizes.TABLET_LANDSCAPE, name: 'tabletPortrait' },
    { size: viewportSizes.LAPTOP, name: 'tabletLandscape' },
    { size: viewportSizes.DESKTOP, name: 'laptop' },
    { size: Infinity, name: 'desktop' },
  ];

  for (const breakpoint of breakpoints) {
    if (viewportWidth < breakpoint.size) {
      return breakpoint.name;
    }
  }

  // Fallback, should not be reached due to Infinity in the last breakpoint
  return 'unknown';
};

export const useCurrentViewport = (): Breakpoint => {
  // Initialize state with undefined width/height
  // so server and client renders match
  const [viewportSize, setViewportSize] = useState<number>(0);
  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => {
      // Set window width/height to state
      setViewportSize(window.innerWidth);
    };
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return getCurrentViewport(viewportSize);
};
